import { render, staticRenderFns } from "./copyBatchMonthPage.vue?vue&type=template&id=5a7ff444&scoped=true&"
import script from "./copyBatchMonthPage.vue?vue&type=script&lang=js&"
export * from "./copyBatchMonthPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7ff444",
  null
  
)

export default component.exports